import type { ColumnDef } from '@tanstack/react-table';
import { createSerialColumn, MemberNameCell } from '@/components/common/DataTable';
import { EmptyValue } from '@/components/common/EmptyValue';
import { formatNumber } from '@/utils/number';
import type { DerDashboardColumn, DerDashboardRow } from '../types/dashboard.types';

export function getDerDashboardColumns(
  expenseTypes: DerDashboardColumn[],
): ColumnDef<DerDashboardRow, unknown>[] {
  return [
    createSerialColumn<DerDashboardRow>(),
    {
      accessorKey: 'name',
      header: 'ZM Name / ID (Cell)',
      cell: ({ row }) => <MemberNameCell member={row.original} />,
    },
    {
      accessorKey: 'amName',
      header: 'AM Name',
      cell: ({ row }) => row.original.amName ?? <EmptyValue />,
    },
    {
      id: 'area',
      header: 'Division / District / Thana',
      cell: ({ row }) => (
        <span className="text-sm">
          {[row.original.divisionName, row.original.districtName, row.original.thanaName]
            .filter(Boolean)
            .join(', ') || '—'}
        </span>
      ),
    },
    ...expenseTypes.map((expenseType) => ({
      id: `expense-${expenseType.id}`,
      header: expenseType.code ?? expenseType.name,
      meta: { title: expenseType.name },
      cell: ({ row }: { row: { original: DerDashboardRow } }) => (
        <span className="tabular-nums">
          {formatNumber(row.original.amounts[String(expenseType.id)] ?? 0)}
        </span>
      ),
    })),
    {
      accessorKey: 'total',
      header: 'Total',
      cell: ({ row }) => (
        <span className="font-medium tabular-nums">{formatNumber(row.original.total)}</span>
      ),
    },
  ];
}
